import str2Html from './text_format_from_back_end'
import html2Str from './text_format_from_front_end'
import { HOST } from '@/constants/message'

export default function formatMessageContentText (text, host) {
    return {
        text: host === HOST.SERVICE
            ? str2Html(text)
            : str2Html(html2Str(text))
    }
}
